import { Box, Fab, Paper, TableCell, TableContainer, Typography } from '@mui/material';
import HomeSegment from './HomeSegment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { useIsAdmin, useUser } from '../atoms';
import { newsAtom, newsListAtom, NewsOptions, newsOptionsState, newsRequestNumberState, newsState, useResetNews } from '../atoms/news';
import { useRecoilState, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import TableView from '../framework/ui/view/table';
import { News } from '../models/News';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import React, { useState } from 'react';
import { useLogger } from '../framework/logger';
import { useConfirmDialog } from './ConfirmDialog';
import excerpts from '../utils/excerpts';
import { useGroupDescriptors } from '../atoms/portale'
import { NullableString } from '../models/ServiceDescriptor';
import { OptionsOpenType } from './HistorySegment';
import { NewsOptionsDialog } from './NewsOptionsDialog';
import { NewsViewDialog } from './NewsViewDialog';
// import logConstants from '../utils/logConstants';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import MailIcon from '@mui/icons-material/Mail';

export function NewsSegment() {
    const latestNews = useRecoilValueLoadable(newsState)
    const setNews = useSetRecoilState(newsAtom)
    const isAdmin = useIsAdmin()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const setListNews = useSetRecoilState<News[]>(newsListAtom)
    const setNewsRequestNumberState = useSetRecoilState<number>(newsRequestNumberState)
    const logger = useLogger({ key: 'news' });
    const { openConfirm, closeConfirm } = useConfirmDialog()
    const { areaDictionary: groupsDic } = useGroupDescriptors()
    const [optionsOpen, setOptionsOpen] = useState<OptionsOpenType>({ open: false })
    const [options, setOptions] = useRecoilState(newsOptionsState)
    const [openNewsView, setOpenNewsView] = useState(false)
    const [index, setIndex]= useState<number>(0)
    const resetNews = useResetNews()
    const user = useUser()

    const handleAddNews = (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        resetNews()
        navigate('ednews/0/0');
    }

    const handleDelete = (item: News) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        if (!isAdmin) {
            logger.warning(t('Non hai i diritti per eseguire l\'operazione'))
            return
        }
        openConfirm({
            title: t('Cancellazione News'),
            prompt: t('Elimino la News?'),
            cancelText: t('Annulla'),
            confirmText: t('Cancella'),
            cancel: () => closeConfirm(),
            confirm: () => {
                api.deleteNews(item.id).then(() => setNewsRequestNumberState(r => r + 1))
                // console.log('Cancellazione Effettuata')
                closeConfirm()
            },
            onClose: () => closeConfirm(),
            children: (
                <>
                    <Typography component='div' sx={{ mb: 0.5, fontWeight: 'bold' }} variant='body1'>{item.title}</Typography>
                    <Typography component='div' sx={{ mb: 2 }} variant='body2'>{item.subtitle}</Typography>
                </>
            )
        })
    }

    const handleEditNews = (item: News) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        console.log('News in Edit', item)
        setNews(item)
        navigate('ednews/' + item.id + '/0');
    }
    
    const handleView = (item: News) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        // console.log('item in View', item)
        setOpenNewsView(true)
        setNews(item)
        let list: News[] = latestNews.contents
        let myIndex = list.findIndex(x => x.id === item.id)
        // console.log('myIndex', myIndex)
        setIndex(myIndex)
    }

    const handleAnnullaNewsView = () => {
        setOpenNewsView(false)
    }

    const formatDate = (d?: string) => {
        if (d) {
            const temp = d.split('.')[0].split('T')
            const t2 = temp[0].split('-')
            return `${t2[2]}/${t2[1]}/${t2[0]}`
        }
    }
    const getTitle = (item: News) => {
        return `News: ${item.title} [${item.id}]`
    }
    const getAree = (value?: NullableString) => {
        if (!value) return ''
        const temp = value.split(';').filter(x => x !== '')
        const rv = temp.map(curr => groupsDic[curr]?.label)
        // console.log(`%cgetAree: ${JSON.stringify(temp)} ${JSON.stringify(rv)} %o`, logConstants.green12ptBold, groupsDic)
        return rv.join(', ')
    }

    const handleToggleOptions = (anchorEl: HTMLDivElement) => {
        setOptionsOpen(current => {
            if (current.open) {
                return { open: false }
            } else {
                return {
                    open: true,
                    anchorEl
                }
            }
        })
    }

    const handleSaveOptions = (o: NewsOptions) => {
        // console.log(`Save Options for News: %o`, o)
        setOptions(o)
        setOptionsOpen(current => ({ ...current, open: false }))
    }
    const handleAnnullaOptions = () => {
        setOptionsOpen(current => ({ ...current, open: false }))
    }

    const handleDeleteOldNews = () => {
        alert('Will delete old news')
    }

    React.useEffect(() => {
        setListNews(latestNews.contents ?? [])
    }, [latestNews, setListNews])

    return (
        <>
            {user.context?.notizia === true && 
            <HomeSegment title='News' nrec={latestNews.contents?.length} onOptionsToggle={handleToggleOptions}>
                <Box sx={{ position: 'relative' }}>
                    {isAdmin && <Fab size="small" color="primary" sx={{ position: 'absolute', top: 4, right: 8, zIndex: 3 }} onClick={handleAddNews}><AddIcon /></Fab>}
                    {latestNews.state === 'hasValue' && latestNews.contents
                        ? <Paper sx={{ mt: 0.5, flexGrow: 1 }}>
                            <TableContainer sx={{ px: 0.5 }}>
                                <TableView
                                    items={latestNews.contents}
                                    itemKey={(item: News) => item.id}
                                    thDefs={<>
                                        <TableCell><Typography color='primary'>{t('Titolo')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Sotto titolo')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Testo')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Valido fino a')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Aree')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Importante')}</Typography></TableCell>
                                        <TableCell><Typography color='primary'>{t('Notifica')}</Typography></TableCell>
                                        {isAdmin &&
                                            <TableCell sx={{ textAlign: 'center' }}><Typography color='primary'>{t('Azioni')}</Typography></TableCell>
                                        }
                                    </>}
                                    trDefs={(row: News) => (<>
                                        <TableCell onClick={handleView(row)} sx={{ cursor: 'pointer', color: (theme) => theme.palette.secondary.dark, fontWeight: 'bold' }} title={getTitle(row)}>{row.title}</TableCell>
                                        <TableCell>{row.subtitle}</TableCell>
                                        <TableCell style={{maxWidth: '250px'}}>{excerpts(row.body, { words: 40 })}</TableCell>
                                        <TableCell><Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>{formatDate(row.validUntil)}{row.expired && <AccessTimeIcon fontSize='small' />}</Box></TableCell>
                                        <TableCell>{getAree(row.aree)}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.important ? 
                                            <PriorityHighIcon color='secondary'/> : null}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.notify ? 
                                            <MailIcon color='secondary'/> : null}
                                        </TableCell>
                                        {isAdmin &&
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer', textAlign: 'center', height: '100%', pb: 0}}>
                                                    <Box onClick={handleDelete(row)} sx={{width: 20, height: 20}}> 
                                                        <DeleteIcon fontSize='small' titleAccess={t('Elimina')} color='primary' />
                                                    </Box>
                                                    <Box onClick={handleEditNews(row)} sx={{width: 20, height: 20}}> 
                                                        <EditIcon fontSize='small' titleAccess={t('Modifica')} color='primary' />
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        }
                                    </>)}
                                />
                            </TableContainer>
                        </Paper>
                        : <Typography>Loading...</Typography>
                    }
                </Box>
            </HomeSegment>
            }
            <NewsOptionsDialog
                open={optionsOpen.open}
                anchorEl={optionsOpen.anchorEl as HTMLElement}
                options={options}
                onSave={handleSaveOptions}
                onAnnulla={handleAnnullaOptions}
                onDelete={handleDeleteOldNews}
                labelView="Visualizza News Scadute"
                labelDelete="Cancelllare news scadute?"
            />
            <NewsViewDialog
                open={openNewsView}
                listNews={latestNews.contents}
                index={index}
                onHandleCloseViewNews={handleAnnullaNewsView}
                atom={newsAtom}
            />
        </>
    )
}

export default NewsSegment;
